import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const UserUpdateNotAllowedError = BaseErrorSchema.extend({
  errorType: z.literal('UserUpdateNotAllowedError'),
  id: z.string(),
});

export type UserUpdateNotAllowedError = z.infer<
  typeof UserUpdateNotAllowedError
>;
